<div class="summary-container">
    <div class="summary-details">
        <div class="summary-subtitle">
            <span>
                {{ 'COMPLAINT|Zgłoszenie z dnia {createdDate}, ostatnio zaktualizowane {modifiedDate}' | translate : {createdDate: (document.created | date: 'shortDate'), modifiedDate: (document.modified | date: 'shortDate')} }}
            </span>
        </div>
        <div class="summary-fields" *ngIf="!preview">
            <div class="summary-fields__container">
                <div class="summary-fields__container__labels">
                    <span class="summary__label" *ngIf="authorizedRetailerStatus">
                        {{ 'COMPLAINT|Status APS' | translate }}
                    </span>
                    <span class="summary__label" *ngIf="distributorStatus">
                        {{ 'COMPLAINT|Status dystrybutora' | translate }}
                    </span>
                    <span class="summary__label" *ngIf="manufacturerStatus">
                        {{ 'COMPLAINT|Status producenta' | translate }}
                    </span>

                    <span class="summary__label">
                        {{ 'COMPLAINT|Indywidualny numer reklamacji' | translate }}
                    </span>

                    <span class="summary__label">
                        {{ 'COMPLAINT|Data planowanej najbliższej wizyty' | translate }}
                    </span>

                    <span class="summary__label" *ngIf="getUserType() === 'manufacturer'">
                        {{ 'COMPLAINT|Numer zamówienia reklamacyjnego' | translate }}
                    </span>

                    <span class="summary__label" *ngIf="getUserType() === 'manufacturer' && document.clientEmail">
                        {{ 'COMPLAINT|Ankieta' | translate }}
                    </span>
                </div>

                <div class="summary-fields__container__values">
                    <span class="summary__content__header" *ngIf="authorizedRetailerStatus">
                        <icc-complaint-status [status]="authorizedRetailerStatus"></icc-complaint-status>
                    </span>
                    <span class="summary__content__header" *ngIf="distributorStatus">
                        <icc-complaint-status [status]="distributorStatus"></icc-complaint-status>
                    </span>
                    <span class="summary__content__header" *ngIf="manufacturerStatus">
                        <icc-complaint-status [status]="manufacturerStatus"></icc-complaint-status>
                    </span>

                    <span class="summary__content__header" [class.no-value]="!document.documentName">
                        {{ document.documentName ?? ('INTERFACE|brak' | translate) }}
                    </span>

                    <span class="summary__content__header" [class.no-value]="!findClosestAppointmentDate()">
                        {{ findClosestAppointmentDate() ? (findClosestAppointmentDate() | date: 'shortDate') : ('INTERFACE|nie ustalono' | translate) }}
                    </span>

                    <span class="summary__content__header" [class.no-value]="!document.complaintOrderNumber" *ngIf="getUserType() === 'manufacturer'">
                        {{ document.complaintOrderNumber ?? ('INTERFACE|brak' | translate) }}
                    </span>

                    <span class="summary__content__header" [class.no-value]="surveyStatus?.status === 'not_sent' || surveyStatus?.status === 'sent_awaiting'" *ngIf="getUserType() === 'manufacturer' && document.clientEmail">
                        <span *ngIf="surveyStatus?.status === 'not_sent'">{{ 'COMPLAINT|nie wysłana' | translate }}</span>
                        <span *ngIf="surveyStatus?.status === 'sent_awaiting'">{{ 'COMPLAINT|wysłana (oczekuje na odpowiedź)' | translate }}</span>
                        <a *ngIf="surveyStatus?.status === 'completed'" (click)="openSurveyPreview()" class="survey-link">
                            {{ 'COMPLAINT|zakończona (otrzymano odpowiedź)' | translate }}
                        </a>
                    </span>
                </div>
            </div>

            <div class="summary-fields__container">
                <div class="summary-fields__container__labels">
                    <span class="summary__label">
                        {{ 'COMPLAINT|Rodzaj zgłoszenia' | translate }}
                    </span>

                    <span class="summary__label" *ngIf="+document.documentTypeId === documentTypes.complaint">
                        {{ 'COMPLAINT|Data zakupu' | translate }}
                    </span>

                    <span class="summary__label">
                        {{ 'COMPLAINT|Podmiot przypisany' | translate }}
                    </span>

                    <span class="summary__label">
                        {{ 'COMPLAINT|Osoba odpowiedzialna' | translate }}
                    </span>

                    <span class="summary__label">
                        {{ 'COMPLAINT|Przypisana osoba' | translate }}
                    </span>

                    <span class="summary__label">
                        {{ 'COMPLAINT|Priorytet' | translate }}
                    </span>
                </div>

                <div class="summary-fields__container__values">
                    <span class="summary__content__header">
                        {{ documentTypesDict[document.documentTypeId] | translate }}
                    </span>

                    <span class="summary__content__header" *ngIf="+document.documentTypeId === documentTypes.complaint">
                        <ng-container *ngIf="document.purchaseDate">{{ document.purchaseDate | date: 'shortDate' }}</ng-container>
                        <ng-container *ngIf="!document.purchaseDate && document.documentTypeId === documentTypes.complaint"><i class="errorMessage">{{ 'COMPLAINT|Wprowadź datę zakupu' | translate}}</i></ng-container>
                    </span>

                    <span class="summary__content__header">
                        {{ getAssignedTo() }}
                    </span>

                    <span class="summary__content__header">
                        {{ getResponsibleUser() }}
                    </span>

                    <span class="summary__content__header">
                        {{ getAssignedUser() }}
                    </span>

                    <span class="summary__content__header">
                        {{ getPriority() }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
